import type { ProjectTemplateFilters } from '../types';

export const PROJECT_TEMPLATE_KEYS = {
  all: ['project-templates'] as const,
  byOrg: (orgId: string) => ['project-templates', orgId] as const,
  list: (orgId: string, filters: ProjectTemplateFilters) =>
    ['project-templates', orgId, 'list', filters] as const,
  detail: (orgId: string, templateId: string) =>
    ['project-templates', orgId, 'detail', templateId] as const,
};
